/**
 * Price-consent status (receipt.priceconsentstatus, PR #497), with human copy + a hover explainer.
 *
 * Platform-neutral encoding written by the receipt cron from Apple `price_consent_status` /
 * Google `priceChange.state`. This is a *forward-looking* churn signal: unlike the cancel reason
 * (which only appears after a sub lapses), a pending-consent state shows up BEFORE renewal.
 */

export interface PriceConsentDoc {
    label: string;
    explainer: string;
    tone: "neutral" | "warn" | "ok";
}

const PRICE_CONSENT: Record<number, PriceConsentDoc> = {
    1: {
        label: "Price increase agreed",
        explainer:
            "The customer was asked to consent to a subscription price increase and agreed. The subscription will renew at the new price.",
        tone: "ok",
    },
    0: {
        label: "Price increase pending",
        explainer:
            "The customer was notified of a consent-required price increase but has NOT yet agreed. If they don't consent, the subscription will lapse at renewal (expiration intent 3). Leading churn signal — a good retention-outreach target.",
        tone: "warn",
    },
    [-1]: {
        label: "No price change",
        explainer:
            "No consent-required price change is pending for this subscription (the normal case — the store reported no price-increase consent flow).",
        tone: "neutral",
    },
};

/**
 * Resolve a price-consent code to its documented meaning. Returns null for null/undefined
 * (not yet polled by the cron) or an unknown code, so the UI can show a distinct "not checked" state.
 */
export function getPriceConsentDoc(code: number | null | undefined): PriceConsentDoc | null {
    if (code == null) return null;
    return PRICE_CONSENT[code] ?? null;
}
